import HfReactHelper from 'js/sign-components/common/hf-react-helper';

export function getPostsignUrl({
  type,
  signerCacheKey,
  isEmbedded,
}: {
  type: string;
  signerCacheKey: string;
  isEmbedded: boolean;
}) {
  const cacheKey = encodeURIComponent(signerCacheKey);

  const searchParams = new URLSearchParams();
  searchParams.set('email_key', cacheKey);
  searchParams.set('is_embedded', isEmbedded ? '1' : '0');

  return HfReactHelper.urlHelper(
    `postsign/${type}?${searchParams.toString()}`,
    HfReactHelper.HfSites.SITE_CODE_HS,
  );
}
